<ng-container *transloco="let t">
  <ejs-dialog
    [isModal]="true"
    [visible]="isVisible()"
    [header]="t('Switch Organization')"
    [showCloseIcon]="true"
    [width]="'480px'"
    (close)="closeDialog()"
    >
    <ng-template #content>
      <div class="dialog-body">
        @switch (store.status()) {
          @case ('Loading') {
            <goatsports-loading-spinner />
          }
          @case ('Error') {
            <div class="error">{{ store.error() || t('error') }}</div>
          }
          @default {
            <div>
              <p class="helper-text">{{ t('Select an organization to switch to') }}</p>
              <ul class="org-list">
                @for (org of store.organizations(); track org) {
                  <li
                    [class.disabled]="org.isActive"
                    [attr.aria-disabled]="org.isActive"
                    [attr.tabindex]="org.isActive ? -1 : 0"
                    (click)="!org.isActive && onSelect(org.uid)"
                    >
                    <div class="org-item">
                      <span class="e-icons e-organization"></span>
                      <span class="name">{{ org.name }}</span>
                    </div>
                    @if (org.isActive) {
                      <span class="badge">{{ t('Active') }}</span>
                    }
                  </li>
                }
              </ul>
            </div>
          }
        }
      </div>
    </ng-template>
    <ng-template #footerTemplate>
      <button ejs-button cssClass="e-btn custom-cancel-btn" (click)="closeDialog()">{{ t('Close') }}</button>
    </ng-template>
  </ejs-dialog>
</ng-container>
